<div
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-targetingResults-cardWrapper-staffCard agpr-recipientCard agpr-contextMenu-parent"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="agpr-targetingResults-card"
        [ngClass]="{'agpr-targetingResults-card-separator' : expanded}"
        (agprClickUnless)="onCardClicked(entityInternal)"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox', 'button']"
        [attr.aria-label]="entityInternal.entityType === entityTypes.CONTACT ? entityInternal.firstName + entityInternal.lastName : entityInternal.name"
        (keydown)="onKeydown($event)"
    >
        <div class="agpr-targetingResults-card-main">
            <div
                class="agpr-targetingResults-card-checkbox"
                *ngIf="!entityInternal.isAdditionalRecipient"
            >
                <agpr-checkbox
                    [id]="id + '_recipientCard_checkbox'"
                    [disabled]="disableSelection"
                    [value]="entityInternal"
                    [hiddenLabel]="entityInternal.entityType === entityTypes.CONTACT ? entityInternal.firstName + entityInternal.lastName : entityInternal.name"
                    [(ngModel)]="selectedResults"
                    (onChange)="checkboxClick()"
                ></agpr-checkbox>
            </div>
            <div
                class="agpr-targetingResults-card-thumbnail"
                [ngClass]="{'agpr-recipientCard-noCheckBox': entityInternal.isAdditionalRecipient}"
            >
                <img
                    class="agpr-targetingResults-card-thumbnail-img"
                    [agprImageSrc]="entityInternal.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                    alt=""
                    [agprDefaultImage]="imageDefault.SMALL_CONTACT"
                />
                <span
                    *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                    role="img"
                    class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                    [agprTooltip]="listMembershipTooltip"
                    [escape]="false"
                ></span>
                <span
                    *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                    class="agpr-targetingResults-card-thumbnail-number agpr-staffCard"
                    [agprTooltip]="listMembershipTooltip"
                    [escape]="false"
                >
                    {{ listMemberships.length }}
                </span>
            </div>
            <div class="agpr-targetingResults-card-description-container agpr-recipientCard">
                <div
                    *ngIf="entityInternal.entityType === entityTypes.CONTACT"
                    class="agpr-targetingResults-card-description"
                >
                    <div class="agpr-targetingResults-card-subcard-name">{{entityInternal.firstName}} {{entityInternal.lastName}}</div>
                    <div
                        *ngIf="entityInternal.selectedEmployment"
                        class="agpr-targetingResults-card-description-jobtitle agpr-targetingResults-overflowEllipsis"
                        [pTooltip]="entityInternal.selectedEmployment.jobTitle"
                    >
                        {{entityInternal.selectedEmployment.jobTitle}}
                    </div>
                    <div
                        *ngIf="entityInternal.selectedEmployment?.outlet"
                        class="agpr-targetingResults-card-description-outlet agpr-targetingResults-card-description-outlet--leftAlign"
                    >
                        <agpr-button
                            [style]="buttonTypes.link"
                            [label]="entityInternal.selectedEmployment.outlet.name"
                            [tooltip]="entityInternal.selectedEmployment.outlet.name"
                            tooltipPosition="top"
                            (click)="focusOutlet(entityInternal)"
                        ></agpr-button>
                    </div>
                    <!-- TODO Need to handle it differently if it is an outlet name with no id
                    (private contacts can refer to an outlet that is not a real jdex entityInternal) -->
                    <div class="agpr-targetingResults-card-description-outlet-container">
                        <a
                            class="agpr-targetingResults-card-description-email"
                            href="mailto:{{ entityInternal.distributedEmail }}"
                            [pTooltip]="entityInternal.distributedEmail | localize"
                            [id]="id + '_emailLink'"
                            [tabindex]="entityInternal.distributedEmail ? 0 : -1"
                        >
                            {{ entityInternal.distributedEmail }}
                        </a>
                    </div>
                </div>

                <div
                    *ngIf="entityInternal.entityType === entityTypes.OUTLET"
                    class="agpr-targetingResults-card-description"
                >
                    <div class="agpr-targetingResults-card-description-outlet-name">{{entityInternal.name}}</div>
                    <div
                        *ngIf="entityInternal.mediaTypes && entityInternal.mediaTypes.length > 0"
                    >
                        <span
                            *ngFor="let mediaType of entityInternal.mediaTypes; let last = last"
                            class="agpr-targetingResults-card-description-outlet-mediaType"
                        >
                            {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                        </span>
                    </div>
                    <div *ngIf="entityInternal.coverageFocus">{{entityInternal.coverageFocus.displayString}}</div>

                    <div class="agpr-targetingResults-card-description-outlet-container">
                        <a
                            class="agpr-targetingResults-card-description-email"
                            href="mailto:{{ entityInternal.distributedEmail }}"
                            [pTooltip]="entityInternal.distributedEmail | localize"
                            [id]="id + '_emailLink'"
                            [tabindex]="entityInternal.distributedEmail ? 0 : -1"
                        >
                            {{ entityInternal.distributedEmail }}
                        </a>
                        <span class="agpr-infoChip">
                            {{topStatLabels.get(entityInternal.topStat) | localize}}
                        </span>
                        <agpr-button
                            class="agpr-targetingResults-card-details-expandButton"
                            [style]="buttonTypes.icon"
                            [icon]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                            [expanded]="expanded"
                            (click)="expanded = !expanded"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        </div>
        @if (entityInternal.entityType === entityTypes.CONTACT) {
            <div class="agpr-targetingResults-card-actions">
                @if (!entityInternal.isAdditionalRecipient && entityInternal.topStat === statTypes.REPLY) {
                    <agpr-button
                        class="agpr-targetingResults-card-details-expandButton"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-messages"
                        (click)="viewConversation.emit(entityInternal.id)"
                        tooltip="Discover.entityProfile.viewConversation"
                    ></agpr-button>
                }
                <span class="agpr-infoChip">
                    {{topStatLabels.get(entityInternal.topStat) | localize}}
                </span>
                <agpr-button
                    class="agpr-targetingResults-card-details-expandButton"
                    [style]="buttonTypes.icon"
                    [icon]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                    [expanded]="expanded"
                    (click)="expanded = !expanded"
                ></agpr-button>
            </div>
        }
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="agpr-contextMenu top right agpr-staffCard"
        *ngIf="!entityInternal.isAdditionalRecipient"
    >
        @if ((dataConnectionService.hasEmailAccountProvision$ | async) && (dataConnectionService.hasEmailAccountConnectors$ | async)) {
            <agpr-button
                [icon]="'fa-regular fa-duotone fa-pen-swirl'"
                (click)="composeEmail.emit(entityInternal.id)"
                class="agpr-targetingResults-cardWrapper-contextMenu-button agpr-staffCard"
                tooltip="Discover.entityProfile.composeEmail"
                tooltipPosition="top"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        }
        <agpr-button
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            (click)="onCardClicked(entityInternal)"
            class="agpr-targetingResults-cardWrapper-contextMenu-button agpr-staffCard"
            tooltip="Discover.entityProfile.expand"
            tooltipPosition="top"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        @if (addToType === targetingAddToTypes.LIST) {
            <agpr-button
                [icon]="'fa-regular fa-duotone fa-user-plus'"
                tooltip="Discover.targeting.actions.manageLists"
                tooltipPosition="top"
                (click)="openManageListDialog(entityInternal)"
                class="agpr-targetingResults-cardWrapper-contextMenu-button agpr-staffCard"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        }
        @if (addToType === targetingAddToTypes.DISTRIBUTION) {
            <agpr-button
                [id]="id + '.manageDist'"
                [icon]="'fa-kit-duotone fa-agpr-add-distribution'"
                tooltipPosition="top"
                (click)="openManageDistDialog(entityInternal)"
                tooltip="Discover.targeting.actions.manageDists"
                class="agpr-targetingResults-cardWrapper-contextMenu-button agpr-staffCard agpr-targetingResults-cardWrapper-contextMenu-button-manageDist"
                [initiallyFocusable]="initiallyFocusable"
                [style]="buttonTypes.contextMenu"
            ></agpr-button>
        }
    </div>

    <div *ngIf="expanded && (otherEvents.length + linkEvents.length) > 0" class="agpr-targetingResults-card-subcard">
        <div *ngFor="let emailEvent of otherEvents">
            <div class="agpr-targetingResults-card-subcard-emailEvent">
                <span class="agpr-targetingResults-card-subcard-emailEvent-type">{{topStatLabels.get(emailEvent.type) | localize}}</span>
                <span class="agpr-targetingResults-card-subcard-emailEvent-date">{{emailEvent.date | changeTimeZone : eventTimeZone : 'MMM D, y - h:mm A'}}</span>
            </div>
        </div>

        <ng-container *ngIf="linkEvents.length > 0">
            <div class="agpr-targetingResults-card-subcard-emailEvent agpr-targetingResults-card-subcard-emailEvent-category">
                <span class="agpr-targetingResults-card-subcard-emailEvent-type">{{'Discover.distributionReport.recipientCards.events.linkClicked' | localize}}</span>
            </div>
            <div *ngFor="let emailEvent of linkEvents">
                <div class="agpr-targetingResults-card-subcard-emailEvent">
                    <a
                        class="agpr-targetingResults-card-subcard-emailEvent-url"
                        [href]="emailEvent.clickedUrl"
                        target="_blank"
                    >
                        {{emailEvent.clickedUrl}}
                    </a>
                    <span class="agpr-targetingResults-card-subcard-emailEvent-date">{{emailEvent.date | changeTimeZone : eventTimeZone : 'MMM D, y - h:mm A'}}</span>
                </div>
            </div>
        </ng-container>
    </div>
</div>
